import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import { externalListsClient } from '~/services';

export const useExternalListsContactCount = createGlobalState(() => {
    const teamId = Spark.state.currentTeam.id;

    // [externalListId]: contactsCount
    // undefined = loading
    // null = not found
    const contactsCount = ref<Record<number, number>>({});

    const fetching = ref(false);

    /**
     * @param {number[]} externalListIds
     */
    const fetchExternalListsContactCount = async (externalListIds: number[]) => {
        // remove existing ids to avoid computing them again
        externalListIds = externalListIds.filter((externalListId) => contactsCount.value[externalListId] == null);

        if (!externalListIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchExternalListsContactCount(externalListIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;
            const request = externalListsClient.getExternalListsContactCount(teamId, {
                external_contact_list_ids: externalListIds,
            });

            const response = await request;

            externalListIds.forEach((externalListId) => {
                contactsCount.value[externalListId] = response.data.counts[externalListId] ?? 0;
            });
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchExternalListsContactCount,
        contactsCount,
    };
});
